import React from 'react';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { Solution } from './components/Solution';
import { HowItWorks } from './components/HowItWorks';
import { Benefits } from './components/Benefits';
import { SocialProof } from './components/SocialProof';
import { Differentiation } from './components/Differentiation';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <main className="min-h-screen bg-navy overflow-hidden flex flex-col" data-id="element-0">
      <Hero data-id="element-1" />
      <Problem data-id="element-2" />
      <Solution data-id="element-3" />
      <HowItWorks data-id="element-4" />
      <Benefits data-id="element-5" />
      <SocialProof data-id="element-6" />
      <Differentiation data-id="element-7" />
      <FinalCTA data-id="element-8" />
      <Footer data-id="element-9" />
    </main>;
}